import { Component } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Credential, DoLoginAction } from '../../store/login/login.action';
import { AppState } from '../../store/login/login.state';
import { PASSWORD_RECOVERY_REQUEST, TAN_LOGIN_ROUTE } from '../../../../routes';
import { BrandingService } from '../../../branding/providers/branding.service';
import { LoginLayoutComponent } from '../../components/login-layout/login-layout.component';
import { NgStyle, AsyncPipe } from '@angular/common';
import { BrowserInfoComponent } from '../../components/browser-info/browser-info.component';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [LoginLayoutComponent, NgStyle, FormsModule, ReactiveFormsModule, BrowserInfoComponent, RouterLink, AsyncPipe, TranslatePipe]
})
export class LoginComponent {
    loginForm: UntypedFormGroup;
    passwordRecoveryRoute = PASSWORD_RECOVERY_REQUEST;
    patientLoginRoute = TAN_LOGIN_ROUTE;

    public backgroundImg$: Observable<any>;
    public showDataSecuritySeal: boolean;

    constructor(private store: Store<AppState>,
                private translate: TranslateService, fb: UntypedFormBuilder,
                private brandingService: BrandingService) {

        this.loginForm = fb.group({
            email: fb.control('', Validators.compose([Validators.required, Validators.email])),
            password: fb.control(
                '',
                Validators.compose([
                    Validators.required,
                    Validators.minLength(8),
                    Validators.maxLength(32),
                ])
            )
        });

        store.select(s => s.login.error).subscribe((httpError: HttpErrorResponse) => {
            if (httpError) {
                if (httpError.status === 429) {
                    this.loginForm.setErrors({
                        rateLimitReached: true
                    });
                } else {
                    this.loginForm.setErrors({
                        notValid: true
                    });
                }
            }
        });

        this.backgroundImg$ = this.brandingService.getBrandingSettingsFromStore().pipe(
            map(settings => {
                const backgroundImg = settings.bgImage_doctorLogin || '/assets/img/general/praxis_bg.jpg';
                return {backgroundImage: backgroundImg};
            }));
    }

    public onSubmit() {
        if (this.loginForm.valid) {
            const credential: Credential = {
                email: this.loginForm.value.email,
                password: this.loginForm.value.password
            };
            this.store.dispatch(new DoLoginAction(credential));
        } else {
            this.loginForm.setErrors({
                notValid: true
            });
        }
    }
}
